import React, { memo, useCallback } from "react";
import { Field } from "formik";
import { TextField } from "formik-material-ui";
import Grid from "@material-ui/core/Grid";
import DialogActions from "@material-ui/core/DialogActions";
import makeStyles from "@material-ui/core/styles/makeStyles";
import DriverInputs from "./driverInputs";
import DriverPassword from "./driverPassword";
import SaveChangesButton from "./saveChangesButton";
import ChangePasswordButton from "./changePasswordButton";
import AddDriverButton from "./addDriverButton";
import DriverCheckboxes from "./driverCheckboxes";
import Autocomplete from "../../../components/Autocomplete";
import {
  DRIVER,
  ODF,
  MAIN_DRIVERS,
  OTHER_DRIVERS,
} from "../../../constants/strings";

const useStyles = makeStyles(({ typography }) => ({
  buttons: {
    padding: `0.5rem 0rem`,
  },
}));

const UpdateDriverForm = ({
  isReadOnly,
  isDisabled,
  driver,
  drivers,
  vehicles,
  sections,
  handleSelectDriver,
  isDriverSelected,
  isSubmitting,
  handleAddDriver,
  handleChangePassword,
  handleSelectOdfDriver,
  odfDrivers,
  odfDriver,
  odfDisabled,
  dirty,
}) => {
  const styles = useStyles();

  const groupByDrivers = useCallback(
    (option) => (option.isActive ? MAIN_DRIVERS : OTHER_DRIVERS),
    []
  );

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={7}>
          <Autocomplete
            onChange={handleSelectOdfDriver}
            value={odfDriver?.driverCode}
            label={ODF}
            variant="outlined"
            options={odfDrivers}
            disabled={isReadOnly || odfDisabled}
            dataTestId="select-odfdriver"
            name="odfRouteOwner"
            popperProps={{ placement: "bottom-start" }}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={7}>
          {driver.isNewDriver ? (
            <Field
              component={TextField}
              name="driverName"
              type="text"
              label="Driver Name"
              placeholder="Forename Surname"
              variant="outlined"
              fullWidth
              data-testid="driver-name"
            />
          ) : (
            <Autocomplete
              onChange={handleSelectDriver}
              value={driver?.driverCode}
              label={DRIVER}
              variant="outlined"
              options={drivers}
              disabled={isReadOnly}
              dataTestId="select-driver"
              groupBy={groupByDrivers}
              popperProps={{ placement: "bottom-start" }}
            />
          )}
        </Grid>
        <Grid item xs={5}>
          <Field
            component={TextField}
            name="displayName"
            type="text"
            label="Display Name"
            helperText="Driver Display Name"
            disabled={isDisabled}
            variant="outlined"
            fullWidth
            data-testid="driver-display-name"
          />
        </Grid>
      </Grid>
      <DriverInputs
        isDisabled={isDisabled}
        vehicles={vehicles}
        sections={sections}
      />
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <DriverCheckboxes isDisabled={isDisabled} />
        </Grid>
        <Grid item xs={3}>
          <DriverPassword password={driver?.password} />
        </Grid>
      </Grid>
      <DialogActions className={styles.buttons}>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <AddDriverButton
              handleAddDriver={handleAddDriver}
              disabled={isReadOnly}
            />
          </Grid>
          <Grid item xs={4} container justify="center">
            {isDriverSelected && (
              <ChangePasswordButton
                handleChangePassword={handleChangePassword}
              />
            )}
          </Grid>
          <Grid item xs={4} container justify="flex-end">
            <SaveChangesButton
              disabled={!dirty || isSubmitting || isDisabled}
            />
          </Grid>
        </Grid>
      </DialogActions>
    </>
  );
};

export default memo(UpdateDriverForm);
